import { render, staticRenderFns } from "./MainApp.vue?vue&type=template&id=6ff30db6&scoped=true&"
import script from "./MainApp.vue?vue&type=script&lang=js&"
export * from "./MainApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff30db6",
  null
  
)

export default component.exports